// Recent search terms, persisted in localStorage and shown when the input is empty.

const RECENT_KEY = "journal:search:recent";
const MAX_RECENT = 6;

function isStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((x) => typeof x === "string");
}

export function loadRecent(): string[] {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    if (!raw) {
      return [];
    }
    const parsed: unknown = JSON.parse(raw);
    if (isStringArray(parsed)) {
      return parsed;
    }
  } catch {
    /* ignore */
  }
  return [];
}

export function saveRecent(term: string, prev: string[]): string[] {
  const next = [term, ...prev.filter((x) => x !== term)].slice(0, MAX_RECENT);
  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}

export function removeRecentTerm(term: string, prev: string[]): string[] {
  const next = prev.filter((x) => x !== term);
  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}
